// extracted by mini-css-extract-plugin
export default {"container":"WlGJ","mainData":"XIrv","actions":"NLgK","itemName":"Jp4K","dateWrapper":"YBfx","btn":"O3e4","descriptionBtn":"uPve","removeBtn":"uxzf","descriptionWrapper":"Ustp"};